import { type FC } from 'react'
import classNames from 'classnames'
import { type ReminderInfo } from '../../../models/Scheduling'
import { getReminderStatus } from '../bookingFormat'

export const ReminderStatus: FC<{ reminder?: ReminderInfo }> = ({ reminder }) => {
  const status = getReminderStatus(reminder)
  if (!status) {
    return null
  }
  return (
    <div className='d-flex align-items-center justify-content-end flex-shrink-0 zocks-gap-0.5 text-end'>
      {status.pill ? (
        <span
          className={classNames(
            'paragraph-small rounded-3 px-2 py-1 text-nowrap',
            status.pill.tone === 'last' ? 'zocks-bg-color-danger-background zocks-text-danger-200' : 'zocks-bg-color-primary-light zocks-text-primary-dark',
          )}
        >
          {status.pill.label}
        </span>
      ) : null}
      {status.detail ? <span className='paragraph-small zocks-text-gray-700 text-nowrap'>{status.detail}</span> : null}
      {status.plain ? <span className='paragraph-small zocks-text-gray-700 text-nowrap'>{status.plain}</span> : null}
    </div>
  )
}
